import React, { Component } from 'react'
import { Alert } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchSupportedDocuments } from '../../actions/supported_documents'
import { CustomPagination } from '../common/custom_pagination/custom_pagination'
import { DivContentBox, DivTitleBox } from '../common/styled'
import Spinner3Bounce from '../spinner_3_bounce'
import { SupportedDocumentsTable } from './supported_documents_table'
import SearchBar from './search_bar'

const recordsPerPage = 10

class SupportedDocumentsComponent extends Component {
  constructor(props) {
    super(props)
    const activePage = this.props.pageHash ? parseInt(this.props.pageHash.split('/').pop(), 0) : 1
    this.state = { activePage, recordsPerPage, searchString: '' }
  }

  componentDidMount() {
    const { activePage, searchString } = this.state
    const { fetchSupportedDocuments } = this.props
    fetchSupportedDocuments(recordsPerPage, (activePage - 1) * recordsPerPage, searchString)
  }

  handleSelectPage = (page) => {
    const { fetchSupportedDocuments } = this.props
    const { activePage, searchString } = this.state

    if (activePage === page) {
      return
    }
    this.setState({ activePage: page })
    fetchSupportedDocuments(recordsPerPage, (page - 1) * recordsPerPage, searchString)
  }

  resetSearch = () => {
    this.setState({
      activePage: 1,
      searchString: '',
    })
    this.props.fetchSupportedDocuments(recordsPerPage)
  }

  search = (searchString) => {
    this.setState({
      activePage: 1,
      searchString,
    })
    this.props.fetchSupportedDocuments(recordsPerPage, (this.state.activePage - 1) * recordsPerPage, searchString)
  }

  searchStringChanged = (searchString) => this.setState({ searchString })

  render() {
    const { state, props } = this
    const { errorMessage, count, results, isFetching } = props

    if (isFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <div className='col-xs-6 col-sm-6'>
              <h2>Supported Documents</h2>
            </div>
            <div className='col-xs-6 col-sm-6'>
              <SearchBar
                onSearchStringChanged={this.searchStringChanged}
                onSearch={this.search}
                onResetSearch={this.resetSearch}
                searchString={state.searchString}
              />
            </div>
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content'>
          <div>
            {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
            <SupportedDocumentsTable results={results} />
            <div>
              {count > recordsPerPage * state.activePage + recordsPerPage && (
                <div>
                  Showing {state.activePage * recordsPerPage - recordsPerPage + 1} to{' '}
                  {recordsPerPage * state.activePage + recordsPerPage} of {count} documents
                </div>
              )}
              <div className='text-center'>
                <CustomPagination
                  activePage={state.activePage}
                  onPageChanged={this.handleSelectPage}
                  totalRecords={count}
                  pageLimit={recordsPerPage}
                />
              </div>
            </div>
          </div>
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.auth.errorMessage,
  isTokenExpired: state.auth.isTokenExpired,
  count: state.fetchSupportedDocuments.count,
  results: state.fetchSupportedDocuments.results,
  isFetching: state.fetchSupportedDocuments.isFetching,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSupportedDocuments,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupportedDocumentsComponent))
